// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__DoY4J","col":"CardReaderDesc_col__3WkzC","label":"CardReaderDesc_label__3oUbl"};